import { render, staticRenderFns } from "./DashBoardTransactionsView.vue?vue&type=template&id=37feccce&scoped=true&"
import script from "./DashBoardTransactionsView.vue?vue&type=script&lang=js&"
export * from "./DashBoardTransactionsView.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardTransactionsView.vue?vue&type=style&index=0&id=37feccce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37feccce",
  null
  
)

export default component.exports